import { BroadcastStateType } from "@/types/graphql/partner.generated";

/** Отправка идёт: состояние и счётчики раз в 10 секунд. */
export const SENDING_POLL_MS = 10_000;
/** Запланирована: до времени запуска раз в минуту. */
export const SCHEDULED_POLL_MS = 60_000;
/** За столько до запуска запланированная опрашивается как отправляемая. */
export const SCHEDULED_SOON_MS = 2 * 60_000;

/**
 * Интервал опроса диалога рассылки (ревью WP-C, M4): отправляемая раз в
 * 10 секунд, запланированная раз в минуту и чаще только за две минуты до
 * запуска, остальные не опрашиваются (0). В скрытой вкладке браузера тик
 * пропускает глобальный skipPollAttempt клиента Apollo.
 */
export function broadcastPollInterval(
  state: BroadcastStateType | null | undefined,
  scheduledAt: string | null | undefined,
  now: number
): number {
  if (state === BroadcastStateType.SendingType) return SENDING_POLL_MS;
  if (state !== BroadcastStateType.ScheduledType) return 0;
  const startsAt = scheduledAt ? Date.parse(scheduledAt) : Number.NaN;
  return Number.isFinite(startsAt) && startsAt - now <= SCHEDULED_SOON_MS
    ? SENDING_POLL_MS
    : SCHEDULED_POLL_MS;
}
